import { environment } from "src/environments/environment";

export const AuthOptions = {
    redirect_uri: environment.AUTH0_REDIRECT_URI,
    audience: environment.AUTH0_AUDIENCE,
    scope: 'openid profile email offline_access'
};